import { badges } from './badge';
import { challenges } from './challenge';
import { level1, level2 } from './level';
export var badgeProgressions = [{
  badge: badges[0],
  badgeProgress: null,
  earnedDate: '2021-04-01T14:30:44Z',
  level: level1
}, {
  badge: badges[1],
  badgeProgress: {
    __typename: 'ChallengeProgress',
    challenge: challenges[3]
  },
  earnedDate: null,
  level: level1
}, {
  badge: badges[2],
  badgeProgress: {
    __typename: 'PointProgress',
    current: 75,
    totalRequired: 100
  },
  earnedDate: null,
  level: level1
}, {
  badge: badges[3],
  badgeProgress: {
    __typename: 'EventProgress',
    current: 2,
    totalRequired: 5,
    eventType: {
      id: '1',
      name: 'Super event'
    }
  },
  earnedDate: null,
  level: level1
}, {
  badge: badges[4],
  badgeProgress: {
    __typename: 'ChallengeTypeCompletionProgress',
    current: 25,
    totalRequired: 100,
    challengeType: {
      id: '1',
      color: '#FFF',
      code: 'abc',
      name: 'Super challenge'
    }
  },
  earnedDate: null,
  level: null
}, {
  badge: badges[5],
  badgeProgress: {
    __typename: 'PointProgress',
    current: 2,
    totalRequired: 10
  },
  earnedDate: null,
  level: null
}, {
  badge: badges[6],
  badgeProgress: {
    __typename: 'PointProgress',
    current: 75,
    totalRequired: 100
  },
  earnedDate: null,
  level: null
}];
export var datedBadgeProgressions = [{
  badge: {
    id: '1',
    name: 'Apr 1 2021 Badge (lvl 1)',
    imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-points-02.png?1580484810',
    description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti. Vestibulum sagittis volutpat velit vel ultrices.' + 'Etiam tincidunt urna id augue rutrum, tincidunt vulputate velit tincidunt. Integer porta eget lacus id egestas.',
    level: level1
  },
  earnedDate: '2021-04-01T14:30:44Z',
  badgeProgress: null
}, {
  badge: {
    id: '3',
    name: '2020 Badge (lvl 3)',
    imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-harassment.png?1580483644',
    description: 'Suspendisse potenti. Vestibulum sagittis volutpat velit vel ultrices.',
    level: level2
  },
  earnedDate: '2020-04-01T14:30:44Z',
  badgeProgress: null
}, {
  badge: {
    id: '5',
    name: 'Badge5',
    imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-education-03.png?1580484661',
    description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti.',
    level: level2
  },
  earnedDate: null,
  badgeProgress: null
}, {
  badge: {
    id: '2',
    name: 'Apr 6 2021 Badge (lvl 2)',
    imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-replies-01.png?1580484236',
    description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti.',
    level: null
  },
  earnedDate: '2021-04-06T12:37:25Z',
  badgeProgress: null
}, {
  badge: {
    id: '8',
    name: 'Badge8',
    imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-share-job-03.png?1580485904',
    description: 'Etiam tincidunt urna id augue rutrum, tincidunt vulputate velit tincidunt.',
    level: null
  },
  earnedDate: null,
  badgeProgress: null
}, {
  badge: {
    id: '11',
    name: 'Other Badge3',
    imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-harassment.png?1580483644',
    description: 'Suspendisse potenti. Vestibulum sagittis volutpat velit vel ultrices.',
    earnedDate: '2021-04-06T12:37:25Z',
    level: null
  },
  earnedDate: '2021-04-06T12:37:25Z',
  badgeProgress: null
}, {
  badge: {
    id: '4',
    name: 'Badge4',
    imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-share-job-03.png?1580485904',
    description: 'Etiam tincidunt urna id augue rutrum, tincidunt vulputate velit tincidunt.',
    level: level2
  },
  badgeProgress: {
    current: 5,
    totalRequired: 25
  },
  earnedDate: null
}, {
  badge: {
    id: '5',
    name: 'Badge5',
    imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-education-03.png?1580484661',
    description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti.',
    level: level2
  },
  earnedDate: null,
  badgeProgress: {
    current: 1,
    totalRequired: 4,
    challengeType: {
      name: 'Share Challenge'
    }
  }
}, {
  badge: {
    id: '6',
    name: 'Badge6',
    imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-replies-03.png?1580484298',
    description: 'Quisque quis ultrices massa, ut pharetra sapien. Suspendisse potenti.',
    level: level2
  },
  earnedDate: null,
  badgeProgress: {
    current: 3,
    totalRequired: 6,
    eventType: {
      name: 'Cool event'
    }
  }
}, {
  badge: {
    id: '7',
    name: 'Badge7',
    imageUrl: 'https://static.influitive.com/influitiveimages/hq/icons/badges/default/hq-badge-points-03.png?1580484918',
    description: 'Suspendisse potenti. Vestibulum sagittis volutpat velit vel ultrices.',
    level: level2
  },
  earnedDate: null,
  badgeProgress: {
    current: 10,
    totalRequired: 100
  }
}];